var React = require('react');

function Success (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 0C12.5375 0 0 12.5375 0 28C0 43.4625 12.5375 56 28 56C43.4625 56 56 43.4625 56 28C56 12.5375 43.4625 0 28 0ZM40.0938 18.8563L26.9312 37.1063C26.7473 37.363 26.5048 37.5722 26.2238 37.7166C25.9428 37.8609 25.6315 37.9362 25.3156 37.9362C24.9998 37.9362 24.6884 37.8609 24.4075 37.7166C24.1265 37.5722 23.884 37.363 23.7 37.1063L15.9062 26.3062C15.6688 25.975 15.9062 25.5125 16.3125 25.5125H19.2437C19.8813 25.5125 20.4875 25.8188 20.8625 26.3438L25.3125 32.5187L35.1375 18.8937C35.5125 18.375 36.1125 18.0625 36.7562 18.0625H39.6875C40.0938 18.0625 40.3313 18.525 40.0938 18.8563Z","fill":"#C3E47C"}));
}

Success.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Success;

Success.default = Success;
